<script setup>
import { computed } from 'vue'
import { useStore } from '@ozdao/martyrs/modules/core/client'

const store = useStore()

const props = defineProps({
  navigationItems: Array,
  theme: {
    type: String,
    default: 'light'
  },
  stateSidebar: {
    type: Boolean,
    default: false
  }
})

const stateSidebar = defineModel('stateSidebar', { type: Boolean, default: false })

// На лендинге в мобильном сайдбаре не выводим якорные ссылки (Возможности, Безопасность и т.д.)
const filteredItems = computed(() => {
  return props.navigationItems.map(section => ({
    ...section,
    items: section.items.filter(item => !item.route?.startsWith('#'))
  })).filter(section => section.items.length > 0)
})

function scrollToSection(route) {
  if (route.startsWith('#')) {
    const scrollview = document.getElementById('scrollview')
    const element = scrollview?.querySelector(route) || document.querySelector(route)
    if (element && scrollview) {
      const top = element.getBoundingClientRect().top + scrollview.scrollTop
      scrollview.scrollTo({ top, behavior: 'smooth' })
    }
  }
  closeSidebar()
}

function closeSidebar() {
  stateSidebar.value = false
  store.core.state.isOpenSidebar = false
}
</script>

<template>
  <nav class="flex flex-column gap-micro pd-small">
    <template v-for="section in filteredItems" :key="section.category">
      <template v-for="item in section.items" :key="item.title">
        <!-- Item с dropdownComponent — рендерим компонент инлайн (тот же,
             что для header-dropdown). Например HeaderMegaMenu — внутри сам
             себя организует под доступную ширину. -->
        <component
          v-if="item.dropdownComponent"
          :is="item.dropdownComponent"
        />

        <!-- Обычный анкорный/роут-пункт -->
        <router-link
          v-else
          :to="item.route"
          @click="scrollToSection(item.route)"
          class="pd-thin radius-small fw-medium cursor-pointer ease-cubic-out-200"
          :class="[
            theme === 'light' ? 'hover:bg-light' : 'hover:bg-dark'
          ]"
        >
          {{ item.title }}
        </router-link>
      </template>
    </template>
  </nav>
</template>
